export const ASTERISK_REGEX = /^\*+|\s*\*+|\*+\s*$/g;
export const UNDERSCORE_REGEX = /^_+|\s+_+|\s*_+\s*$/g;
export const LEFT_CURLY_REGEX = /^{+|{+|\s*{*$/g;
export const RIGHT_CURLY_REGEX = /^}+|}+|\s*}*$/g;
export const UNDERSCORE_IN_MIDDLE_REGEX = /_+\B|\B_+/g;
